import { c as _c } from "react/compiler-runtime";
import type { FC, ReactNode } from 'react';
type Props = {
  children: ReactNode;
  className?: string;
};

// Single-line text container: truncates with an ellipsis by default; hover unlocks horizontal scroll.
const ScrollableText: FC<Props> = t0 => {
  const $ = _c(4);
  const {
    children,
    className
  } = t0;
  const t1 = typeof children === "string" ? children : undefined;
  const t2 = `overflow-hidden text-ellipsis whitespace-nowrap [-ms-overflow-style:none] [scrollbar-width:none] hover:overflow-x-auto hover:text-clip [&::-webkit-scrollbar]:hidden ${className ?? ""}`;
  let t3;
  if ($[0] !== children || $[1] !== t1 || $[2] !== t2) {
    t3 = <div title={t1} className={t2}>{children}</div>;
    $[0] = children;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
export default ScrollableText;